class EquipeModel {
    constructor(id, name, teamtag, logo, wins = 0, losses = 0, statut = null) {
        this.id = id;
        this.name = name;
        this.teamtag = teamtag;
        this.logo = logo;
        this.wins = wins;
        this.losses = losses;
        this.statut = statut;
    }

    static fromJSON(json) {
        return new EquipeModel(json.id, json.name, json.teamtag, json.logo, json.wins, json.losses, json.statut ?? null);
    }
}

export default EquipeModel;
